import $ from '@ali/tarzan-zepto';
import IScroll from 'iscroll/build/iscroll-probe.js';
import events from 'events';
import UnRead from '../unread/';
import util from '../../../../lib/util.js';

const ANI_CLASSNAME = 'ani-transform-scroll';
const showTimeInterval = 60000;
let lastShowTime = new Date();


class Scroll extends events {
  constructor(config) {
    super();
    this.$container = $(config.container);
    this.__init();
    this.iscroll = this.__initIScroll();
    this.__bindEvent();
    this.__initUnRead();
  }

  __init() {
    this.$chartPanel = $('<div class="m-alicare-chartPanel"></div>');
    this.$el = $('<div class="m-alicare-scroller"></div>');
    this.$el.append(this.$chartPanel);
    this.$container.html(this.$el);
  }

  __initIScroll() {
    return new IScroll(this.$container[0], {
      probeType: 3,
      useTransition: false,
      mouseWheel: true,
      tap: false,
      click: false,
      scrollY: true,
      scrollX: false,
      lockDirection: true,
      disablePointer: true,
      disableTouch: false,
      disableMouse: false,
      scrollbars: !!util.isPC(),
      preventDefaultException: {
        tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|P|DIV)$/,
      },
    });
  }

  __bindEvent() {
    this.__pullEvent();
    this.on('resize', util.buffer(() => {
      this.refresh();
    }, 200, this));
  }

  __initUnRead() {
    this.unRead = new UnRead({
      container: this.$container,
    });

    this.unRead.on('trigger', (node) => {
      if (node) {
        this.scrollToElement(node[0]);
      }
    });
  }

  __pullEvent() {
    const iscroll = this.iscroll;
    const scroller = $(iscroll.scroller);
    let pullFlag = false;

    iscroll.on('scroll', () => {
      this.rmAnimation();
      if (scroller.position().top > 20 && !pullFlag) {
        pullFlag = true;
      }
      if (scroller.position().top > 0) {
        this.emit('pullEvent', {
          dis: scroller.position().top,
        });
      }
      if (this.isBottom()) {
        // this.unRead.hide();
      }
    });

    iscroll.on('scrollEnd', () => {
      this.addAnimation(1000);
      if (pullFlag) {
        this.emit('pull');
      }
      pullFlag = false;
    });
  }

  addAnimation(time = 0) {
    setTimeout(() => {
      this.$el.addClass(ANI_CLASSNAME);
    }, time);
  }

  rmAnimation() {
    this.$el.removeClass(ANI_CLASSNAME);
  }

  __append($content) {
    this.$chartPanel.append($content);
  }

  __prepend($content) {
    this.$chartPanel.prepend($content);
  }

  append(content) {
    const $el = $(content);
    const isBottom = this.isBottom();
    if (!$el || !$el.length) {
      return;
    }

    // this.showTime();
    this.__append($el);
    this.resize();
    if (isBottom) {
      this.scrollToBottom();
      this.unRead.hide();
      this.imageOnScrollToBottom($el);
    } else {
      // this.unRead.add($el);
    }

    this.imageOnLoad($el);
  }

  prepend(content) {
    const $el = $(content);
    if (!$el || !$el.length) {
      return;
    }
    this.__prepend($el);
    this.resize();
    this.imageOnLoad($el);
  }


  isBottom() {
    const iscroll = this.iscroll;
    return Math.abs(iscroll.maxScrollY - iscroll.y) < 5;
  }

  refresh() {
    if (this.iscroll) this.iscroll.refresh();
  }

  resize() {
    this.emit('resize');
  }

  scrollToElement(el) {
    this.iscroll.scrollToElement(el);
  }

  scrollToTop() {
    this.iscroll.scrollTo(0, 0);
  }

  scrollToBottom() {
    const iscroll = this.iscroll;
    // 滚动到底部之前，先refresh
    iscroll.refresh();
    iscroll.scrollTo(0, iscroll.wrapperHeight - iscroll.scrollerHeight);
  }

  imageOnLoad(el) {
    $(el).find('img').on('load', this.refresh);
  }

  imageOnScrollToBottom(el) {
    $(el).find('img').on('load', () => {
      this.scrollToBottom();
    });
  }

  showTime() {
    const now = new Date();
    const nowString = now.toLocaleString('zh-CN', { hour12: false }).replace(/\//g, '/').replace(/\b\d\b/g, '0$&').slice(0, -3);
    if (now - lastShowTime > showTimeInterval) {
      lastShowTime = now;
      this.__append(`
        <div class="m-chatpanel-item m-chatpanel-system">
          <div class="body">
          ${nowString}
          </div>
        </div>
      `);
    }
  }
}

export default Scroll;



// WEBPACK FOOTER //
// ./src/component/view/body/scroll/scroll.js